export const NEXT_SOUND = "/sounds/Next01.mp3";

export const playNextSound = (): void => {
  const audio = new Audio(NEXT_SOUND);
  audio.volume = 0.125;
  void audio.play().catch(() => undefined);
};
